module.exports = __webpack_public_path__ + "img/two_bg.0e22d8e7.jpg";